import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-inbound-calls',
  templateUrl: './inbound-calls.component.html',
  styleUrls: ['./inbound-calls.component.scss']
})
export class InboundCallsComponent implements OnInit {
  @Input() results: any;
  @Input() colors: any;
  @Input() config: any;

  constructor() {}

  ngOnInit() {}
}
